import { useLocation } from 'react-router-dom'

export const useIsNewDesign = () => {
  const location = useLocation()
  return !location.pathname.includes('old') && !location.pathname.includes('office') && !location.pathname.includes('all-packages-view')
}
